import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface KpiCardProps {
  label: string;
  value: string | number;
}

const KpiCard: React.FC<KpiCardProps> = ({ label, value }) => {
  return (
    <Card className="w-full max-w-sm border border-gray-200 rounded-lg shadow-md">
      <CardHeader className="p-4 md:p-6">
        <CardTitle className="text-lg font-semibold text-gray-700">
          {label}
        </CardTitle>
      </CardHeader>
      <CardContent className="p-4 pt-0 md:p-6 md:pt-0">
        <div className="text-3xl font-bold text-gray-900">{value}</div>
      </CardContent>
    </Card>
  );
};

export default KpiCard;
